import Vue from 'vue';
import { GlobalState } from '../../global-state/global-state';
import { AddToSamplesButton } from '../../components/product-samples/add-to-samples-button-component';
import { ToggleQuickshopSidebar } from '../../components/product-quickshop/toggle-quickshop-component';
import {
  setGTMcompareProductsEvent,
  checkProductIsInCompareArray,
} from '../../utils/helpers';
import { addSample, getSampleButtonText, hasReachedLimit, isProductInSamplesArray, shouldDisabledSampleButton, checkSampleThresholdReached } from '../../components/product-samples/product-samples';

class vuePDPComponents {
  compareBadge() {
    new Vue({
      el: '#product-hero__compare-badge',
      data: {
        sharedState: GlobalState.state,
      },
      mounted() {
        this.isProductInCompareArray();
      },
      methods: {
        addToCompare: function (event) {
          const els = document.querySelector('[data-product-form]');
          const compareCart = GlobalState.getCompareList(this);
          const alreadyInArray = checkProductIsInCompareArray(
            compareCart,
            els.dataset.productHandle
          );

          if (!alreadyInArray) {
            const dataElement = event.currentTarget.parentElement;
            const buttonElement = event.currentTarget;
            let url = buttonElement.attributes['data-redirect-url'].value;

            if (compareCart.length <= 3) {
              compareCart.push({
                compareListPosition: compareCart.length,
                id: parseInt(dataElement.attributes['data-id'].value),
                handle: dataElement.attributes['data-handle'].value,
                title: dataElement.attributes['data-title'].value,
                imageSource: dataElement.attributes['data-image-source'].value,
              });

              buttonElement.innerHTML = 'View Compare';
              buttonElement.addEventListener(
                'click',
                function () {
                  window.location.href = url;
                },
                true
              );

              GlobalState.setCompareList(this, compareCart);

              // Set Google GTM Data Layer Veriable
              const gtmCompareProducts = GlobalState.getCompareList(this).map(
                (product) => product.title
              );
              setGTMcompareProductsEvent(gtmCompareProducts, 'PDP');
            }
          }
        },
        isProductInCompareArray: function () {
          const els = document.querySelector('[data-product-form]');

          const compareList = GlobalState.getCompareList(this);
          const isInArray = checkProductIsInCompareArray(
            compareList,
            els.dataset.productHandle
          );

          if (isInArray) {
            let button = document.querySelector('#product-hero__compare-badge');
            button.firstElementChild.innerHTML = 'Added to Compare';
            button.firstElementChild.classList.add('disabled');
            button.firstElementChild.setAttribute('disabled', true);
          }
        },
      },
    });
  }
  sampleBadge() {
    if (!document.querySelector('#product-hero__sample-badge')) {
      return;
    }
    new Vue({
      el: '#product-hero__sample-badge',
      data: {
        sampleButtonText: '',
        displayErrors: false,
        samplingDisabled: window.theme && window.theme.samplingDisabled,
      },
      mounted() {
        // repeatedly check until window.CartJS is available
        const check = () =>
          setTimeout(() => {
            if (window.CartJS?.cart?.items) {
              this.checkSampleThresholdReached();
            } else {
              check();
            }
          }, 1000);
        check();
      },
      methods: {
        addToSamples: function (event) {
          // Security guard: prevent sampling if disabled globally
          if (this.samplingDisabled) {
            return;
          }

          event.target.disabled = true;

          const els = document.querySelector('[data-product-form]');
          const isKit = [true, 'true'].includes(els.dataset.sampleKit);
          if (hasReachedLimit(isKit ? els.dataset.sampleKitWeight : 1)) {
            this.displayErrors = true;
            setTimeout(() => {
              this.displayErrors = false;
            }, 3000);
            return;
          }

          if (isProductInSamplesArray(els.dataset.sampleVariantId)) return;

          addSample(els.dataset.sampleVariantId, els.dataset.sampleHandle || els.dataset.productHandle, 'PDP', isKit, isKit ? els.dataset.sampleKitWeight : 1).then(() => {
            // Wait for cart update to complete before checking sample status
            setTimeout(() => {
              const variantId = els.dataset.sampleVariantId;
              const sampleKitWeight = els.dataset.sampleKitWeight;
              checkSampleThresholdReached(variantId, isKit, sampleKitWeight);
              event.target.disabled = false;
            }, 1000); // Wait 1 second for cart update
          });
        },
        checkSampleThresholdReached: function () {
          const els = document.querySelector('[data-product-form]');
          const isKit = [true, 'true'].includes(els.dataset.sampleKit);
          const text = getSampleButtonText(els.dataset.sampleVariantId, isKit ? els.dataset.sampleKitWeight : 1);

          // If it's a kit and the text is "Request Sample", change it to "Request Sample Kit"
          let finalText = text;
          if (isKit && text === 'Request Sample') {
            finalText = 'Request Sample Kit';
          }

          this.updateButtonText(finalText, shouldDisabledSampleButton(text));
        },
        updateButtonText: function (text, isDisabled = false) {
          let buttonContainer = document.querySelector('#product-hero__sample-badge');
          let button = buttonContainer.querySelector('button');

          button.innerHTML = `${text}`;
          this.sampleButtonText = text;

          // Check if sampling is disabled globally
          const globallyDisabled = this.samplingDisabled;

          if (isDisabled || globallyDisabled) {
            button.classList.add('cta-button--disabled');
            button.setAttribute('disabled', true)
            button.classList.remove('sample');
          } else {
            button.classList.remove('cta-button--disabled');
            button.classList.remove('cta-button--grey');
            button.removeAttribute('disabled');
            button.classList.add('sample');
          }
        },
      },
    });
  }
  relatedProductSlider() {
    if (!document.querySelector('#related-product-slider')) {
      return;
    }
    new Vue({
      el: '#related-product-slider',
      components: {
        'add-to-samples': AddToSamplesButton,
        'toggle-quickshop': ToggleQuickshopSidebar,
      },
    });
  }
}
export default vuePDPComponents;
